"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRelatedPagesDataPayloadFromJSON = AdminRelatedPagesDataPayloadFromJSON;
exports.AdminRelatedPagesDataPayloadFromJSONTyped = AdminRelatedPagesDataPayloadFromJSONTyped;
exports.AdminRelatedPagesDataPayloadToJSON = AdminRelatedPagesDataPayloadToJSON;
exports.AdminRelatedPagesDataPayloadToJSONTyped = AdminRelatedPagesDataPayloadToJSONTyped;
const runtime_1 = require("../runtime");
function AdminRelatedPagesDataPayloadFromJSON(json) {
    return AdminRelatedPagesDataPayloadFromJSONTyped(json, false);
}
function AdminRelatedPagesDataPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
        'layoutId': !(0, runtime_1.exists)(json, 'layoutId') ? undefined : json['layoutId'],
        'disconnectedPages': !(0, runtime_1.exists)(json, 'disconnectedPages') ? undefined : json['disconnectedPages'],
    };
}
function AdminRelatedPagesDataPayloadToJSON(value) {
    return AdminRelatedPagesDataPayloadToJSONTyped(value, false);
}
function AdminRelatedPagesDataPayloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'layoutId': value.layoutId,
        'disconnectedPages': value.disconnectedPages,
    };
}
